var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10239",
    "data-name": "Group 10239",
    transform: "translate(7110.75 19490.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10235",
    "data-name": "Group 10235",
    transform: "translate(-7110 -19484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7289",
    "data-name": "Path 7289",
    className: "cls-1",
    d: "M81,171H56V152H81Z",
    transform: "translate(-56 -152)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10236",
    "data-name": "Group 10236",
    transform: "translate(-7105.5 -19488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7293",
    "data-name": "Path 7293",
    className: "cls-2",
    d: "M16,16H0",
    transform: "translate(0 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10237",
    "data-name": "Group 10237",
    transform: "translate(-7103.5 -19490)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7294",
    "data-name": "Path 7294",
    className: "cls-2",
    d: "M12,16H0",
    transform: "translate(0 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10238",
    "data-name": "Group 10238",
    transform: "translate(-7107.5 -19486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7292",
    "data-name": "Path 7292",
    className: "cls-2",
    d: "M20,16H0",
    transform: "translate(0 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvWhite);
export default __webpack_public_path__ + "static/media/pvWhite.9de7f3afc9b5149fd4927d7998e3a28b.svg";
export { ForwardRef as ReactComponent };